export default __webpack_public_path__ + "2c7e437f75e3bb2cf30a29c4498ca91b.woff2";